(function () {
  const STORAGE_KEY = 'carla:wishlist';
  const isEnglish = (document.documentElement.lang || '').split('-')[0] === 'en';
  const fallbackLabels = isEnglish ? { view: 'View product', remove: 'Remove from wishlist' } : { view: 'Zobacz produkt', remove: 'Usuń z listy życzeń' };
  const translatedLabels = document.querySelector('wishlist-drawer')?.dataset;
  const labels = { view: translatedLabels?.viewLabel || fallbackLabels.view, remove: translatedLabels?.removeLabel || fallbackLabels.remove };

  function readItems() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) { return []; }
  }
  function writeItems(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) { /* storage unavailable */ }
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items } }));
  }
  function hasItem(id) { return readItems().some((item) => String(item.id) === String(id)); }
  function itemFromButton(button) {
    return { id: button.dataset.wishlistId, handle: button.dataset.wishlistHandle || '', title: button.dataset.wishlistTitle || '', url: button.dataset.wishlistUrl || '', image: button.dataset.wishlistImage || '', price: button.dataset.wishlistPrice || '' };
  }
  function toggleItem(item) {
    if (!item.id) return false;
    const items = readItems();
    const index = items.findIndex((entry) => String(entry.id) === String(item.id));
    let added;
    if (index > -1) { items.splice(index, 1); added = false; }
    else { items.unshift(item); added = true; }
    writeItems(items);
    return added;
  }
  function removeItem(id) { writeItems(readItems().filter((entry) => String(entry.id) !== String(id))); }
  function syncButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const liked = hasItem(button.dataset.wishlistId);
      button.classList.toggle('is-liked', liked);
      button.setAttribute('aria-pressed', liked ? 'true' : 'false');
    });
  }
  function updateCount() {
    const count = readItems().length;
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => { el.textContent = count; el.toggleAttribute('hidden', count === 0); });
    document.querySelectorAll('.wishlist-floating').forEach((el) => el.classList.toggle('wishlist-floating--has-items', count > 0));
  }
  function escapeHtml(value) {
    return String(value ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  class WishlistDrawer extends HTMLElement {
    constructor() {
      super();
      this.body = this.querySelector('[data-wishlist-items]');
      this.emptyTemplate = this.querySelector('[data-wishlist-empty]')?.outerHTML || '';
      this.renderVersion = 0;
    }
    connectedCallback() {
      this.addEventListener('keyup', (event) => { if (event.code === 'Escape') this.close(); });
      this.render();
    }
    open(trigger) { this.activeElement = trigger || document.activeElement; this.classList.add('active'); document.body.classList.add('overflow-hidden'); this.render(); }
    close() {
      this.classList.remove('active'); document.body.classList.remove('overflow-hidden');
      if (this.activeElement && typeof this.activeElement.focus === 'function') this.activeElement.focus();
    }
    itemMarkup(item) {
      const url = window.CarlaLocalizedProducts?.url(item) || item.url || '';
      const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy" width="80" height="100">` : '<div class="wishlist-item__placeholder"></div>';
      return `<li class="wishlist-item" data-wishlist-line="${escapeHtml(item.id)}">
        <a class="wishlist-item__media" href="${escapeHtml(url)}">${image}</a>
        <div class="wishlist-item__details">
          <a class="wishlist-item__title" href="${escapeHtml(url)}">${escapeHtml(item.title)}</a>
          <p class="wishlist-item__price">${escapeHtml(item.price)}</p>
          <a class="wishlist-item__link" href="${escapeHtml(url)}">${labels.view}</a>
        </div>
        <button type="button" class="wishlist-item__remove" data-wishlist-remove data-wishlist-id="${escapeHtml(item.id)}" aria-label="${labels.remove}">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
        </button></li>`;
    }
    render() {
      const version = ++this.renderVersion;
      if (!this.body) return;
      const items = readItems();
      if (!items.length) { this.body.innerHTML = this.emptyTemplate; return; }
      this.body.innerHTML = `<ul class="wishlist-items" role="list">${items.map((item) => this.itemMarkup(item)).join('')}</ul>`;
      if (!window.CarlaLocalizedProducts) return;
      items.forEach((item) => {
        window.CarlaLocalizedProducts.get(item).then((localized) => {
          if (version !== this.renderVersion || !this.isConnected) return;
          const row = Array.from(this.body.querySelectorAll('[data-wishlist-line]')).find((el) => el.dataset.wishlistLine === String(item.id));
          if (!row) return;
          const url = window.CarlaLocalizedProducts.url(localized);
          row.querySelectorAll('a').forEach((link) => link.setAttribute('href', url));
          const title = row.querySelector('.wishlist-item__title');
          if (title) title.textContent = localized.title || '';
          const image = row.querySelector('img');
          if (image) { image.alt = localized.title || ''; if (localized.image) image.src = localized.image; }
          const price = row.querySelector('.wishlist-item__price');
          if (price) price.textContent = localized.price || '';
        });
      });
    }
  }
  if (!customElements.get('wishlist-drawer')) customElements.define('wishlist-drawer', WishlistDrawer);
  function getDrawer() { return document.querySelector('wishlist-drawer'); }
  function onClick(event) {
    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) { event.preventDefault(); event.stopPropagation(); toggleItem(itemFromButton(toggle)); return; }
    const opener = event.target.closest('[data-wishlist-open]');
    if (opener) { event.preventDefault(); getDrawer()?.open(opener); return; }
    const closer = event.target.closest('[data-wishlist-close]');
    if (closer && closer.closest('wishlist-drawer')) {
      if (closer.tagName !== 'A') event.preventDefault();
      getDrawer()?.close(); return;
    }
    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) { event.preventDefault(); removeItem(remove.dataset.wishlistId); }
  }
  function refreshUI() { syncButtons(); updateCount(); getDrawer()?.render(); }
  document.addEventListener('click', onClick);
  document.addEventListener('wishlist:change', refreshUI);
  document.addEventListener('shopify:section:load', refreshUI);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshUI); else refreshUI();
  window.addEventListener('storage', (event) => { if (event.key === STORAGE_KEY) refreshUI(); });
})();
